module.exports = __webpack_public_path__ + "img/up_arrow.13c5d810.svg";